module.exports = __webpack_public_path__ + "media/images/pic/lectors/klaudia-mucha-iwaniczko-fbd7c73587f08bfa9c516f1e971f2371.jpeg";